var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiAgentIndicator = function SvgAiAgentIndicator(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#aiIndicator24Gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C12.1881 8 12.3564 8.1164 12.4225 8.2925L13.3191 10.6813L15.7075 11.5771C15.8836 11.6432 16 11.8116 16 11.9996C16 12.1878 15.8837 12.3568 15.7075 12.4229L13.3191 13.3179L12.4225 15.7075C12.3564 15.8836 12.1881 16 12 16C11.8119 16 11.6436 15.8836 11.5775 15.7075L10.6801 13.3179L8.2925 12.4229C8.1163 12.3568 8 12.1878 8 11.9996C8.0001 11.8116 8.1164 11.6432 8.2925 11.5771L10.6801 10.6813L11.5775 8.2925L11.6069 8.2293C11.6859 8.0890 11.8354 8 12 8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aiIndicator24Gradient",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8762FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512DEE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiAgentIndicator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ai-agent-indicator.663ea7178987ccb0e35b4bfb3cd6ce4c.svg";